<template>
    <div class="findPw" id="findPw">
        <div class="container">
            <div class="py-5">
                <GoodWizard ref="wizard" :steps="steps" :onNext="nextClicked" :onBack="backClicked">
                    <div slot="page1" class="slot mx-auto">
                        <h4 class="text-center">패스워드 찾기</h4>
                        <div class="my-5">
                            <div class="form-group input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">이메일</span>
                                </div>
                                <input @keyup.enter="nextClicked(0)" required autofocus
                                       v-model="email" ref="email" class="form-control" placeholder="가입시 입력하신 이메일을 입력해주세요." type="text" value="">
                            </div>
                        </div>
                    </div>

                    <div slot="page2" class="slot mx-auto">
                        <h4 class="text-center">이메일 확인</h4>

                        <div class="my-5">
                            이메일이 발송되었습니다. 이메일로 전송된 인증코드를 인증해주세요.
                        </div>

                        <div class="form-group input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"> 인증코드</span>
                            </div>
                            <input v-model="member.joinAuthCode" type="text">
                        </div>
                        <div class="form-group input-group">
                            <button type="button" class="btn btn-danger btn-block" v-on:click="emailAuthorization()">
                                인증 확인
                            </button>
                        </div>

                    </div>
                    <div slot="page3" class="slot mx-auto">
                        <h4 class="text-center">패스워드 변경</h4>

                        <div v-if="authorized" class="my-5">
                            패스워드를 변경해주세요.
                        </div>

                        <div v-if="authorized" class="form-group input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"> 비밀번호 </span>
                            </div>
                            <input class="form-control" ref="pw1" placeholder="패스워드를 입력하세요" type="password" v-model="pw.pw1">
                        </div>
                        <div v-if="authorized" class="form-group input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"> 비밀번호 확인 </span>
                            </div>
                            <input class="form-control" ref="pw2" placeholder="한번 더 입력하세요" type="password" v-model="pw.pw2">
                        </div>

                        <div v-if="authorized" class="form-group">
                            <button type="button" class="btn btn-primary btn-block" v-on:click="changePw()">
                                입력완료
                            </button>
                        </div>
                    </div>
                </GoodWizard>
            </div>
        </div>
    </div>
</template>
<script>
    import { GoodWizard } from 'vue-good-wizard';
//TODO 기능 구현
    export default {
        name: 'forgotpw',
        components: {
          GoodWizard
        },
        data() {
            return {
                authorized:false,
                email:'',
                steps: [
                    {
                        label: '이메일 입력',
                        slot: 'page1',
                    },
                    {
                        label: '이메일 확인',
                        slot: 'page2',
                    },
                    {
                        label: '패스워드 변경',
                        slot: 'page3',
                        options: {
                            nextDisabled: true, // control whether next is disabled or not
                        },
                    }
                ],
                pw: {
                    pw1:'',
                    pw2: '',
                },
                member: {
                    email:'',
                    password:'',
                    joinAuthCode:''
                }
            };
        },
        methods: {
            nextClicked(currentPage) {
                let canNext = false;
                if(currentPage == 0) { // 이메일 입력
                    if(this.email != '') {
                        this.sendEmailForPassword();
                    } else {
                        this.$root.$children[0].commonDialog('패스워드 분실', '이메일을 입력해주세요.');
                        //this.$refs.email.focus();
                        canNext=false;
                    }
                } else if(currentPage == 1) {
                    if(this.authorized) canNext=true;
                    else canNext=false;
                }
                return canNext; //return false if you want to prevent moving to next page
            },
            backClicked(currentPage) {
                //console.log('back clicked', currentPage);
                return true; //return false if you want to prevent moving to previous page
            },
            sendEmailForPassword() {
                let me = this;
                this.axios.put(process.env.VUE_APP_AUTH_API_URL + '/forgotpw/'+this.email)
                    .then(function (res) {
                        if(res.data) {
                            me.$root.$children[0].commonDialog('패드워드 분실', '이메일을 확인해주세요.');
                            me.$refs['wizard'].goTo(1);
                        } else {
                            me.$root.$children[0].commonDialog('패드워드 분실', '가입되지 않은 이메일입니다.');
                            me.$refs['wizard'].goTo(0);
                        }
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            emailAuthorization() {
                let me = this;
                this.axios.get(process.env.VUE_APP_AUTH_API_URL + `/${me.member.joinAuthCode}`)
                    .then(function (res) {
                        if(res.data) {
                            me.$root.$children[0].commonDialog('인증완료','패스워드를 변경해주세요.');
                            me.$refs['wizard'].goTo(2);
                            me.authorized = true;
                        } else
                            me.$root.$children[0].commonDialog('인증실패','인증코드를 다시 확인해주세요.');
                    }).catch(function (error) {
                    console.log(error);
                    //alert(' 에러');
                });
            },
            changePw() {
                if(this.pw.pw1.length < 8 || this.pw.pw1.length > 12) {
                    this.$parent.commonDialog('패스워드 변경','비밀번호는 특수문자 포함 8자와 12자 사이에서 입력 가능합니다.');
                } else if(this.pw.pw1 != this.pw.pw2) {
                    this.$parent.commonDialog('패스워드 변경','패스워드가 일치하지 않습니다.');
                } else {
                    this.member.email = this.email;
                    this.member.password = this.pw.pw1;
                    let me = this;
                    this.axios.put(process.env.VUE_APP_AUTH_API_URL + '/changepw', this.member)
                        .then(function (res) {
                            if(res.data) {
                                me.$root.$children[0].commonDialog('패드워드 분실', '패스워드가 변경되었습니다. 로그인해주세요');
                                me.$router.push({ name: 'login'})
                            } else {
                                me.$root.$children[0].commonDialog('패드워드 분실', '패스워드 변경에 실패하였습니다.');
                                return false;
                            }
                        }).catch(function (error) {
                        //console.log(error);
                        alert(error);
                    });
                }
            }


        },

        computed: {},
        mounted() {
        }
    };
</script>
<style>
    .divider-text span {
        padding: 7px;
        font-size: 12px;
        position: relative;
        z-index: 2;
    }

    .slot {
        max-width:450px;

    }
</style>